import moment from 'moment';
import { Poll, PollStatus } from './types';

export const getStatus = (poll: Poll): PollStatus => {
  const start = moment(poll?.startTime);
  const end = moment(poll?.endTime);
  const now = moment();

  if (now.isSameOrAfter(end)) {
    return 'FINISHED';
  }
  if (now.isSameOrAfter(start)) {
    return 'ONGOING';
  }

  return 'UPCOMING';
};

export interface PollsDataGridFormat {
  id: string;
  createdAt: string;
  title: string;
  result: number | undefined;
  resultError?: boolean;
  name: string;
  type: string;
  poll: Poll;
}

export const convertFirestorePollsToDatagridFormat = (data: Poll): PollsDataGridFormat => {
  const id = data.id;
  const createdAt = moment(data.createdAt).format('YYYY-MM-DD HH:mm');
  const title = data.title;
  const name = data.name;
  const type = data.type;

  return {
    id,
    createdAt,
    title,
    name,
    type,
    result: undefined,
    poll: data,
  };
};
